<template>
  <div>
      <v-card>
        <v-card-title>
            <v-toolbar color="primary" dark>
                <v-toolbar-title aling="center">Importación masiva de colaboradores</v-toolbar-title>
            </v-toolbar>
        </v-card-title>
        <v-card-subtitle class="d-flex justify-center">
          
        </v-card-subtitle>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-file-input
                  accept=".xlsx"
                  label="Ingrese la tabla en excel segun el formato"
                  outlined
                  v-model="chosenFile"
                >
                </v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
            <v-btn dark color="blue" :href="api+'public/EjemploCargaMasiva.xlsx'">Ver Ejemplo</v-btn>
          <v-spacer></v-spacer>
            <v-btn dark color="success" @click="enviar" v-if="datos.length > 0">Guardar</v-btn>
        </v-card-actions>
      </v-card>

      <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-data-table
            :headers="headers"
            :items="datos"
            :items-per-page="5"
            class="elevation-1"
            :search="search"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>

  </div>
</template>
<script>
import axios from "axios";
import api from "../conf/ruta-base";
import router from '../router';
import store from "../store";
import readXlsxFile from 'read-excel-file'
import moment from "moment";
moment.locale('es');
import swal from 'sweetalert';
export default {
  name: 'excel',
  data() {
    return {
      chosenFile: null, search: '',
      headers: [
        { text: "Nombres", value: "nombres"},
        { text: "Apellidos", value: "apellidos"},
        { text: "Correo", value: "correo"},
        { text: "Supervisor", value: "supervisor"},
        { text: "Cargo", value: "cargo"},
        { text: "Departamento", value: "dep"},
        { text: "Grupo", value: "grupo"},
      ],
      datos:[],
      api: null,
    }
  },
  mounted() {
      this.api = api.api
  },
  methods: {
    decodeXlsx(){
      readXlsxFile(this.chosenFile).then((rows) => {
        if(rows[0][0]!='Codigo'){
          swal('','Lo siento no he podido validar el documento, favor verificalo','error')
          return null
        }
        for(let i = 1; i < rows.length; i++){
          var supervisor
          for(let j = 1; j < rows.length; j++){
            if(rows[i][1]==rows[j][0]){
              supervisor = rows[j][3] + ' ' + rows[j][4]
              break
            }
            else{
              supervisor = 'Sin Supervisor'
            }
          }
          let datos = {
            codigo: rows[i][0],
            codsup: rows[i][1],
            supervisor,
            correo: rows[i][2],
            nombres: rows[i][3],
            apellidos: rows[i][4],
            nacimiento: moment(rows[i][5]).format('L'),
            ingreso: moment(rows[i][6]).format('L'),
            cargo: rows[i][7],
            coddep: rows[i][8],
            dep: rows[i][9],
            grupo: rows[i][10],
            telefono: rows[i][11],
          }
          if(this.validar(rows[i]))
            this.datos.push(datos)
        }
      })
    },
    validar(row){
      //Validamos todo menos row[1] que corresponde al codigo del supervisor de la persona
      if(row[0].length < 1 || row[2].length < 1 || row[3].length < 1 || row[4].length < 1 || row[5].length < 1)
        return false
      if(row[10].length < 1 || row[6].length < 1 || row[7].length < 1 || row[8].length < 1 || row[9].length < 1 || row[11].length < 1)
        return false
      if(!/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(row[2]))
        return false
      return true
    },
    enviar(){
      for(let i = 0; i < this.datos.length; i++){
        let nc=this.datos[i].nacimiento.split('/')
        this.datos[i].nacimiento = nc[2]+'-'+nc[1]+'-'+nc[0]
        let ig=this.datos[i].ingreso.split('/')
        this.datos[i].ingreso = ig[2]+'-'+ig[1]+'-'+ig[0]
        this.datos[i].api = api.api
        console.log(this.datos[i])
      }
      axios
        .post(api.api + 'user/masivo', this.datos)
        .then(res => {
          this.toast(res.data.c, res.data.mensaje);
          router.push('/usuarios')
        })
        .catch(error => {
            console.log(error);
        });
    },
    toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
    }
  }, 
  watch: {
    chosenFile(val){
      if(val != undefined){
        this.decodeXlsx()
      }else{
        this.datos = []
      }
    }
  },
}
</script>